import { render, staticRenderFns } from "./ActivityShow.vue?vue&type=template&id=8e89bcc4"
import script from "./ActivityShow.vue?vue&type=script&lang=js"
export * from "./ActivityShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports